import React from 'react';
import {
    SearchSuggestionList,
    SearchSuggestionListItem,
    ShowAllListItem,
    ShowSearchResultButton,
    SuggestionsPopOver,
    Heading,
} from './AutoCompleteResult.styles';
import { getId, value } from './helpers';
import PopOverLink from './PopOverLink';
import { BUTTON_THEME } from '../../../ui-components/PlayButton/PlayButton';

const AutoCompleteButton = ({ searchTerm, onClick }) => {
    return (
        <ShowAllListItem>
            <ShowSearchResultButton
                to="/sok"
                query={{ q: searchTerm }}
                onAfterClick={onClick}
                regTestSpec="search-result-btn"
                theme={BUTTON_THEME.DARK}
            >
                <span className="play_search-suggestions__show-all-icon" aria-hidden="true" />
                Visa alla sökträffar
            </ShowSearchResultButton>
        </ShowAllListItem>
    );
};

const PopOver = ({ result, suggestionClick, term, onAllMatchesClick }) => (
    <SuggestionsPopOver portal={false} data-state="suggesting">
        {result.name && <Heading>{result.name}</Heading>}
        <SearchSuggestionList>
            {result.hits.map((item) => {
                return (
                    <SearchSuggestionListItem key={getId(item)} value={value(item)}>
                        <PopOverLink item={item} suggestionClick={suggestionClick} />
                    </SearchSuggestionListItem>
                );
            })}
            {term !== '' && <AutoCompleteButton searchTerm={term} onClick={onAllMatchesClick} />}
        </SearchSuggestionList>
    </SuggestionsPopOver>
);

export default PopOver;
